module.exports = __webpack_public_path__ + "static/media/a2.411f432b.pdf";